<div class="cover" #container>
  <div class="hero">
      <p>>{{letMeHelp}}<span class="classColor">{{you}}</span><span class="methodColor">{{dotAchieve}}</span>{{p1}}<span class="variableColor">{{yourGoals}}</span>{{p2}} <span class="typing">{{typing1}}</span> <br>{{standOut}} <span class="typing">{{typing2}}</span> <br>{{smiley}} <span class="typing">{{typing3}}</span> </p>
  </div>
  <a class="know-more"
    (click)="scrollToAbout()">Wanna know more?</a>
  <a class="to-services"
    (click)="scrollToServices()">My Services</a>
</div>